import Modal from "react-bootstrap/Modal";

import logo from "../../assets/img/logo.svg";
import { useRef } from "react";
import useInput from "../../hooks/use-input";
import { useSelector } from "react-redux";

type SearchModalProps = {
  onHide: () => void;
  show: boolean;
  searchAndCreateRepository: (repoName: string) => Promise<void>;
};

const SearchModal = (props: SearchModalProps) => {
  const { userName } = useSelector((state: any) => state.auth);

  const repositoryNameInput = useRef<HTMLInputElement>(null);

  const {
    value: repositoryNameValue,
    valueChangeHandler: repositoryNameChangeHandler,
    inputBlurHandler: repositoryNameBlurHandler,
    reset: resetRepositoryName,
  } = useInput();

  const searchAndCreateRepositoryFormSubmitHandler = async (
    event: React.FormEvent
  ): Promise<void> => {
    event.preventDefault();
    props.searchAndCreateRepository(repositoryNameValue);
    resetRepositoryName();
    props.onHide();
  };

  return (
    <Modal
      id="ModalRepos"
      size="lg"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="ModalRepos"
      aria-hidden="true"
      {...props}
    >
      <div className="modal-content">
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={props.onHide}
        >
          <span aria-hidden="true">&times;</span>
        </button>
        <div className="modal-body text-center">
          <img alt="base" src={logo} className="mb-4" />
          <h4 className="user-title">
            Logged In as <span className="font-weight-bold">{userName}</span>
          </h4>
          <div className="zone">
            <form onSubmit={searchAndCreateRepositoryFormSubmitHandler}>
              <div className="form-group">
                <label htmlFor="repositoryName">
                  Search papers by keywords
                </label>
                <input
                  type="text"
                  className="form-control form-control-sm"
                  id="repositoryName"
                  aria-describedby="userNameHelp"
                  ref={repositoryNameInput}
                  value={repositoryNameValue}
                  onChange={repositoryNameChangeHandler}
                  onBlur={repositoryNameBlurHandler}
                />
              </div>
              <button
                type="submit"
                className="btn btn-primary btn-block modal-btn"
              >
                Search Arxiv and create repository
              </button>
            </form>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SearchModal;
